/* eslint-disable @typescript-eslint/no-floating-promises */
import { Flex } from '@chakra-ui/react'
import ApexCharts from 'apexcharts'
import { useEffect } from 'react'
import { NivelCriterioResponse } from '../../../../../interfaces'
interface BarChartProps {
  id: string
  data: NivelCriterioResponse[]
  onClickNivel?: (nivel: NivelCriterioResponse) => void
}

export const CriterioBarChart: React.FC<BarChartProps> = ({ id, data, onClickNivel }) => {
  function QuebrarEmDuasLinhas(texto: string): string | string[] {
    if (texto.length <= 50) return texto
    const meio = texto.length / 2
    let corte = -1
    for (let i = 0; i < texto.length; i++) {
      if (texto[i] === ' ' && (corte === -1 || Math.abs(i - meio) < Math.abs(corte - meio))) corte = i
    }
    if (corte === -1) return texto
    return [texto.slice(0, corte), texto.slice(corte + 1)]
  }

  function GerarGrafico(): void {
    const options = {
      series: [
        {
          data: data.sort((a, b) => b.pontuacao - a.pontuacao).map(e => e.qtdUsos)
        }
      ],
      colors: data.map(e => {
        return '#1961E0'
      }),
      chart: {
        type: 'bar',
        height: data.length * 60 > 120 ? data.length * 60 : 120,
        width: 800,
        events: {
          dataPointSelection: function (_e: any, _ctx: any, config: any) {
            onClickNivel?.(data[config.dataPointIndex])
          },
          dataPointMouseEnter: function (e: any) {
            if (onClickNivel) e.target.style.cursor = 'pointer'
          }
        }
      },
      states: {
        active: {
          filter: {
            type: 'none'
          }
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val: any) {
            return val + (val > 0 ? ' usos' : ' uso')
          },
          title: {
            formatter: function () {
              return 'Qtd. usos:'
            }
          }
        }
      },
      grid: {
        show: false
      },
      legend: {
        show: false
      },
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top'
          },
          distributed: true
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -10,
        style: {
          colors: ['#fff']
        },
        textAnchor: 'end',
        formatter: function (val: any) {
          if (val > 0) {
            return val
          }

          return ''
        }
      },
      xaxis: {
        labels: {
          show: true,
          hideOverlappingLabels: true
        },
        categories: data.map(e => QuebrarEmDuasLinhas(`${e.nome} (Pontuação: ${e.pontuacao})`)),
        title: {
          style: {
            color: '#000',
            fontSize: '20px',
            fontWeight: 600
          }
        }
      },
      yaxis: {
        min: 0,
        labels: {
          maxWidth: 600
        }
      }
    }

    const chart = new ApexCharts(document.querySelector(`#chart-${id}`), options)
    chart.render()
  }

  useEffect(() => {
    GerarGrafico()
  }, [data])

  return <Flex id={`chart-${id}`} />
}
